import React from "react";
import pic from "../../../icons/summary.jpg";

class ManagementLeft extends React.Component {

    render() {
        return (
            <div className='word-wrap'>
                <h2>Site management</h2>
                <div style={{marginTop:'30px'}}>Provide us information about management</div>
                <div className='left-pane-pic'>
                    <img src={pic} alt="Logo" />
                </div>
            </div>
        );
    }
}
export default ManagementLeft




// WEBPACK FOOTER //
// ./src/components/CreateSite/Step5/ManagementLeft.js